import { connect } from 'react-redux';
import selectors from '../../rootSelectors';
import ScreenErrorView from './ScreenErrorView';
import { logUserOut } from '../user/userActions';

const mapStateToProps = (state) => ({
    screenLevelErrorStatusCode: selectors.getScreenLevelErrorStatus(state)
});

const mapDispatchToProps = () => ({
    logUserOut,
});

const ScreenErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ScreenErrorView);

export default ScreenErrorContainer;
